import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "style.css";

interface GalleryImage {
  src: string;
  alt: string;
}

interface SubGalleryProps {
  images: GalleryImage[];
  bgColor?: string;
}

const SubGallery: React.FC<SubGalleryProps> = ({
  images,
  bgColor = "#131c81",
}) => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const openAt = (i: number) => {
    setIndex(i);
    setOpen(true);
  };

  const [hero, ...thumbs] = images;

  return (
    <>
      <div className="sub-gallery-hero-wrap">
        <img
          src={hero.src}
          alt={hero.alt}
          className="sub-gallery-hero"
          style={{ backgroundColor: bgColor }}
          onClick={() => openAt(0)}
          loading="lazy"
        />
      </div>

      {thumbs.length > 0 && (
        <div className="sub-gallery-thumbs">
          {thumbs.map((img, i) => (
            <img
              key={img.src}
              src={img.src}
              alt={img.alt}
              className="sub-gallery-thumb"
              style={{ backgroundColor: bgColor }}
              onClick={() => openAt(i + 1)}
              loading="lazy"
            />
          ))}
        </div>
      )}

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        index={index}
        slides={images.map((img) => ({ src: img.src, alt: img.alt }))}
      />
    </>
  );
};

export default SubGallery;
